import { AbstractControl } from "@angular/forms";

/**
 * Just a stupid helper method to manage the enabled state of an AbstractControl and simplify call-sites.
 *
 * The given control is returned so that another action on the control can be chained.
 *
 * @param control
 * @param enabled
 * @param onlySelf When true, mark only this control. When false or not supplied, marks all direct ancestors. Default is
 * false.
 * @param emitEvent: When true or not supplied (the default), both the `statusChanges` and  `valueChanges` observables
 * emit events with the latest status and value when the control is enabled. When false, no events are emitted.
 */
export function setEnabled(control: AbstractControl, enabled: boolean, onlySelf?: boolean, emitEvent?: boolean): AbstractControl
{
    const config = {
        onlySelf,
        emitEvent
    };
    if (enabled)
    {
        control.enable(config);
    }
    else
    {
        control.disable(config);
    }

    return control;
}
